function JobConfigurationPage() {
    /**
     *
     */
    JobConfigurationPage.prototype.initialize = function (console, job) {
        this.id = "jobConfiguration";
        this.console = console;

        if (job) {
            this.jobId = job.id;
            this.job = this.console.consoleService.filterTransient(job);

            Job.bind(this.console.node, this.job);
        }
        else {
            this.job = Job.create(this.console.node);
        }

        return this;
    };

    /**
     *
     */
    JobConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.nodeConfigurationScope = 5;

        this.date = new Date(moment(this.job.startTimestamp).valueOf());
        this.time = new Date(moment(this.job.startTimestamp).valueOf());

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    JobConfigurationPage.prototype.serviceTypeChanged = function () {
        if (this.job.action.type == "nodeService") {
            this.job.action.content.service = this.console.node.services.length ? this.console.node.services[0] : null;
        }
    };

    /**
     *
     */
    JobConfigurationPage.prototype.timestampChanged = function () {
        var startTimestamp = moment(this.date);
        var time = moment(this.time);

        startTimestamp.hour(time.hour());
        startTimestamp.minute(time.minute());
        startTimestamp.second(time.second());

        this.job.startTimestamp = startTimestamp.format();
    };

    /**
     *
     */
    JobConfigurationPage.prototype.createJob = function () {
        this.console.consoleService.createJob(this.console.node, this.job).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to add Job.", "error");
        }.bind(this));
    };

    /**
     *
     */
    JobConfigurationPage.prototype.updateJob = function () {
        this.console.consoleService.updateJob(this.console.node, this.job).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to change Job.", "error");
        }.bind(this));
    };

    /**
     *
     */
    JobConfigurationPage.prototype.leave = function () {
    };
}
